export function transformInvestments(investments) {
  const today = new Date().toISOString().split("T")[0];

  const transformedInvestments = [];

  for (const investment of investments) {
    const initialInvestment = {
      cashflow: -investment.cashflow,
      investmentDate: investment.investmentDate,
    };
    transformedInvestments.push(initialInvestment);

    const capitalGain = {
      cashflow:
        investment.capitalGain + investment.cashflow !== 0
          ? investment.capitalGain + investment.cashflow
          : 0.0001,
      investmentDate: today,
    };
    transformedInvestments.push(capitalGain);
  }

  return transformedInvestments;
}

export function transformDivestments(investments) {
  const transformedInvestments = [];

  for (const investment of investments) {
    const initialInvestment = {
      cashflow: -investment.cashflow,
      investmentDate: investment.investmentDate,
    };
    transformedInvestments.push(initialInvestment);

    const capitalGain = {
      cashflow:
        investment.capitalGain + investment.cashflow !== 0
          ? investment.capitalGain + investment.cashflow
          : 0.0001,
      investmentDate: investment.divestmentDate,
    };
    transformedInvestments.push(capitalGain);
  }

  return transformedInvestments;
}
